import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useMatch } from "react-router-dom";
import {
  setFolderActive,
  setPageActive,
  setMenuTreeDatas,
  setMenus,
  setBodySearch,
  setIsSearchKeyword
} from "../features/common/documents-repository/documents";
import APP_URL from "../declaration/URL";

export const useResetDocument = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const pathName = location.pathname;

  const matchDocumentDetail = useMatch("/app/documents/:documentId/detail");
  const matchDocumentEdit = useMatch("/app/documents/:documentId/edit");
  const matchDocumentList = useMatch("/app/documents");
  const matchDocumentCreate = useMatch("/app/documents/register");

  useEffect(() => {
    if (!matchDocumentDetail && !matchDocumentEdit && !matchDocumentList && !matchDocumentCreate) {
      dispatch(setPageActive(1));
    }

    if (!pathName.startsWith(`/app${APP_URL.document.list}`)) {
      localStorage.removeItem("folderActiveDocument");
      localStorage.removeItem("menus");
      localStorage.removeItem("menuTreeDatas");
      dispatch(
        setFolderActive({
          folder_name: null,
          folder_uuid: null
        })
      );
      dispatch(setMenus([]));
      dispatch(setMenuTreeDatas([]));
      dispatch(
        setBodySearch({
          folder_uuid: [
            {
              keyword: null,
              condition: "EQ"
            }
          ]
        })
      );
      dispatch(setIsSearchKeyword(false));
    }
  }, [dispatch, matchDocumentDetail, matchDocumentEdit, matchDocumentList, pathName, matchDocumentCreate]);
};
